import { SxStyles } from 'types/styles';
import { basicTheme } from 'theme';

export const styles: SxStyles = {
  root: {
    '& .MuiOutlinedInput-root': {
      pl: 4,
      minHeight: 54,
      backgroundColor: basicTheme.palette.mainPalette.white,
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 8px 8px 0px',
      color: basicTheme.palette.mainPalette.dark,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: basicTheme.palette.mainPalette.disabled,
      borderWidth: 1,
    },

    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: basicTheme.palette.mainPalette.mult50,
    },
    '&&& .Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: basicTheme.palette.systemPalette.red + ' !important',
    },
    '&&& .MuiFormHelperText-root': {
      color: basicTheme.palette.systemPalette.red + ' !important',
    },
  },
};
